import React from 'react';
import clsx from 'clsx';
import logo from '../assets/images/bg/logo.svg';

const AuthShell = ({ children, maxWidth = 520, showLogo = true }) => (
  <div
    className="auth-container"
    style={{
      minHeight: '100vh',
      height: 'auto',
      overflowY: 'scroll',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 24,
      background:
        'radial-gradient(900px 500px at 0% 0%, rgba(0,77,84,0.08) 0%, rgba(0,77,84,0) 60%), radial-gradient(800px 420px at 100% 0%, rgba(0,77,84,0.06) 0%, rgba(0,77,84,0) 60%), linear-gradient(135deg, #f5fbfb 0%, #eef8f8 100%)',
    }}
  >
    <div style={{ width: '100%', maxWidth }}>
      {showLogo ? (
        <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'center' }}>
          <img src={logo} alt="VitalStaf" style={{ height: 48 }} />
        </div>
      ) : null}
      {children}
    </div>
  </div>
);

export default AuthShell;


